var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.232 4.494a2.69 2.69 0 0 0 1.008 2.432c.483.384.76.957.76 1.574a2 2 0 0 1-.76 1.574 2.69 2.69 0 0 0-1.008 2.432c.07.613-.139 1.215-.575 1.65a2 2 0 0 1-1.65.576 2.7 2.7 0 0 0-2.433 1.008c-.383.483-.957.76-1.574.76s-1.19-.277-1.574-.76a2.69 2.69 0 0 0-2.432-1.008 2 2 0 0 1-1.65-.575 2 2 0 0 1-.576-1.65A2.69 2.69 0 0 0 .76 10.073 2 2 0 0 1 0 8.5c0-.617.277-1.19.76-1.574a2.69 2.69 0 0 0 1.008-2.432c-.07-.613.139-1.215.575-1.65a2 2 0 0 1 1.65-.576A2.69 2.69 0 0 0 6.427 1.26C6.809.777 7.383.5 8 .5s1.19.277 1.574.76a2.69 2.69 0 0 0 2.432 1.008c.613-.07 1.215.139 1.65.575.437.436.647 1.038.576 1.65m-2.938 2.505a.987.987 0 1 0-1.557-1.211L7.335 8.874 5.933 7.541a.987.987 0 0 0-1.36 1.43l2.192 2.084a.987.987 0 0 0 1.459-.11z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckIcon;